import { Person } from "models/stateTypes/authState";
import { ComponentBaseProps } from "models/propTypes/basePropTypes";
import { RoundButtonProps, StyledButtonProps } from "./commonPropTypes";
import { IconDefinition } from "./iconPropTypes";
import { CustomFormFieldsProps } from "./genericFormProps";

export interface UserProfileProps {
  userName: string;
  profileId?: number;
  companyName: string;
  loadProfilePicture?: (id: number) => void;
}

export interface ProfileMoreActionsProps {
  userName: string;
  button: React.ReactElement<StyledButtonProps | RoundButtonProps>;
  navCollapsed: boolean;
}

export interface ProfileImageProps extends ComponentBaseProps {
  id?: number;
  name?: string;
  showDefaultAvatar?: boolean;
}

export interface ProfImageLoggedInUserProps {
  loggedInUser: Person;
}

export interface UserProps extends PersonProps {}

export class User implements ProfileImageProps {
  id?: number;
  name?: string;
  hideUserName?: boolean;
  hideProfileImage?: boolean;
  disableLink?: boolean;

  constructor(id?: number, name?: string, hideUserName?: boolean, hideProfileImage?: boolean, disableLink?: boolean) {
    this.id = id;
    this.name = name;
    this.hideUserName = hideUserName;
    this.hideProfileImage = hideProfileImage;
    this.disableLink = disableLink;
  }
}

export interface PersonProps extends ProfileImageProps {
  hideUserName?: boolean;
  href?: string;
  onProfileClick?: () => void;
  hideProfileImage?: boolean;
  disableLink?: boolean;
}

export class OrganizationInfo {
  id?: number;
  name?: string;
  orgNr?: string;
  onProfileClick?: () => void;

  constructor(id?: number, name?: string, orgNr?: string) {
    this.id = id;
    this.name = name;
    this.orgNr = orgNr;
  }
}

export interface OrganizationProps extends OrganizationInfo {
  href?: string;
}

export class IconProfileInfo {
  name: string;
  description?: string;
  icon: IconDefinition | string;
  hideIconBackground?: boolean;
  showIconOnly?: boolean;
  plainTitle?: boolean;

  constructor(
    name: string,
    icon: IconDefinition | string,
    description?: string,
    hideIconBackground?: boolean,
    showIconOnly?: boolean,
    plainTitle?: boolean
  ) {
    this.name = name;
    this.description = description;
    this.icon = icon;
    this.hideIconBackground = hideIconBackground;
    this.showIconOnly = showIconOnly;
    this.plainTitle = plainTitle;
  }
}

export interface IconProfileProps extends IconProfileInfo {}

export class FileProfileInfo {
  fileName: string;
  contentType: string;

  constructor(fileName: string, contentType: string) {
    this.fileName = fileName;
    this.contentType = contentType;
  }
}

export interface FileProfileProps extends FileProfileInfo {}

export class Customer {
  id?: number;
  name?: string;
  orgNr?: string;
  onProfileClick?: () => void;

  constructor(id?: number, name?: string, orgNr?: string) {
    this.id = id;
    this.name = name;
    this.orgNr = orgNr;
  }
}

export interface CustomerProps extends Customer, ComponentBaseProps {}

export class Supplier {
  id?: number;
  name?: string;
  orgNr?: string;
  onProfileClick?: () => void;

  constructor(id?: number, name?: string, orgNr?: string, onClick?: () => void) {
    this.id = id;
    this.name = name;
    this.orgNr = orgNr;
    this.onProfileClick = onClick;
  }
}

export interface SupplierProps extends Supplier, ComponentBaseProps {}

export class IncomingInvoiceProfile {
  id: number;
  displayText: string;

  constructor(id: number, displayText: string) {
    this.id = id;
    this.displayText = displayText;
  }
}

export interface IncomingInvoiceProfileProps extends IncomingInvoiceProfile {}

export class ReceiptProfile {
  id: number;
  displayText: string;

  constructor(id: number, displayText: string) {
    this.id = id;
    this.displayText = displayText;
  }
}

export interface ReceiptProfileProps extends ReceiptProfile {}

export class PaymentMethodProfile {
  id: number;
  displayText: string;

  constructor(id: number, displayText: string) {
    this.id = id;
    this.displayText = displayText;
  }
}

export interface PaymentMethodProfileProps extends PaymentMethodProfile {}

export interface EmployeeProfileProps extends ComponentBaseProps, CustomFormFieldsProps {
  value?: any;
}

export class CustomLink {
  link: string;
  displayText: string;

  constructor(link: string, displayText: string) {
    this.link = link;
    this.displayText = displayText;
  }
}

export interface CustomLinkProps extends CustomLink {
  forceReplacingUrl?: boolean;
}

export interface MultiProfilesProps extends MultiPersonNamesProps {
  showWint?: boolean;
}

export interface MultiPersonNamesProps {
  profiles: {
    id: number;
    name: string;
  }[];
  maxProfiles?: number;
}
